import styled from '@emotion/styled';

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: ${({ theme }) => theme.semantic.SpaceComponentS}px;
`;

export const StyledLinkContainer = styled.div`
  margin-top: ${({ theme }) => theme.semantic.SpaceComponentS}px;
`;
